import React from 'react';
import styles from './FilterSectionLoader.scss';

const FilterSectionLoader = () => (

    <div className={styles.skeletonLoader}>
        <span className={styles.topBar}>
            <div className={styles.heading}></div>
            <div className={styles.cross}></div>
        </span>
        <div className={styles.title}></div>
        <div className={styles.box}></div>

        <div className={styles.title}></div>
        <div className={styles.box}></div>

        <div className={styles.title}></div>
        <div className={styles.box}></div>

        <div className={styles.title}></div>
        <div className={styles.box}></div>
    </div>

)


export default FilterSectionLoader






// WEBPACK FOOTER //
// ./src/containers/SearchPage/FilterSectionLoader/index.tsx